export default "__VITE_ASSET__DwEpNtum__"